import React, { useEffect, useState } from 'react';

import './styles.scss';

const cardWidth = 185;

const Carousel = ({ carouselData, onButtonClick, onImageClick }) => {
  const [totalCarouselElements, setTotalCarouselElements] = useState(0);
  const [currentCardIndex, setCurrentCardIndex] = useState(1);
  const [shiftX, setShiftX] = useState(0);
  const [carouselId, setCarouselId] = useState('');
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    setCarouselId(new Date().getTime());
  }, []);

  useEffect(() => {
    if (carouselId) {
      setContentHeight(
        document
          .querySelector(`#code7-boteria__carousel__content__${carouselId}`)
          ?.getBoundingClientRect()?.height
      );
    }
  }, [carouselId, carouselData]);

  useEffect(() => {
    if (carouselData?.cards) {
      const { cards } = carouselData;

      setTotalCarouselElements(carouselData.cards.length);

      if (cards.length === 1) {
        const slider = document.querySelector(
          `.code7-boteria__carousel_row-${carouselId}`
        );
        setShiftX(0);
        setCurrentCardIndex(1);
        slider.style.transform = `translateX(0px)`;
      }
    }
  }, [carouselData, carouselId]);

  const handlePrevCard = () => {
    const slider = document.querySelector(
      `.code7-boteria__carousel_row-${carouselId}`
    );

    if (currentCardIndex > 1) {
      slider.classList.toggle('code7-boteria__card--move');

      const updatedShift = shiftX - cardWidth;
      setShiftX(updatedShift);
      setCurrentCardIndex(currentCardIndex - 1);
      slider.style.transform = `translateX(-${updatedShift}px)`;
    } else if (currentCardIndex === 1) {
      const updatedShift = totalCarouselElements * cardWidth - cardWidth;
      setShiftX(updatedShift);

      slider.classList.toggle('code7-boteria__card--move');
      slider.style.transform = `translateX(-${updatedShift}px)`;
      setCurrentCardIndex(totalCarouselElements);
    }
  };

  const handleNextCard = () => {
    const slider = document.querySelector(
      `.code7-boteria__carousel_row-${carouselId}`
    );

    if (currentCardIndex < totalCarouselElements) {
      slider.classList.toggle('code7-boteria__card--move');

      const updatedShift = cardWidth + shiftX;
      setShiftX(updatedShift);
      slider.style.transform = `translateX(-${updatedShift}px)`;
      setCurrentCardIndex(currentCardIndex + 1);
    } else {
      setShiftX(0);
      setCurrentCardIndex(1);
      slider.style.transform = `translateX(0px)`;
    }
  };

  const handleButtonClick = ({ clickedButton, clickedCard }) => {
    if (onButtonClick) {
      onButtonClick({ clickedButton, clickedCard });
    }
  };

  return (
    <div
      className="code7-boteria__carousel__wrapper"
      style={{
        height: contentHeight,
      }}
    >
      <ul className="code7-boteria__carousel__container">
        <span className="code7-boteria__accessibility-item">
          Navegue pela lista de opções abaixo e prescione o botão do card
          desejado
        </span>
        {carouselData.cards.length > 1 && (
          <>
            <div className="code7-boteria__carousel__background-left" />
            <span
              className="code7-boteria__carousel__button code7-boteria__carousel__button--left"
              onClick={() => handlePrevCard()}
              tabIndex="-1"
            >
              {'<'}
            </span>

            <div className="code7-boteria__carousel__background-right" />
            <span
              className="code7-boteria__carousel__button code7-boteria__carousel__button--right"
              onClick={() => handleNextCard()}
              tabIndex="-1"
            >
              {'>'}
            </span>
          </>
        )}

        <div
          className="code7-boteria__carousel__content"
          id={`code7-boteria__carousel__content__${carouselId}`}
        >
          <div
            className={`code7-boteria__carousel_row code7-boteria__carousel_row-${carouselId}`}
            style={{
              width: `${(cardWidth + 10) * carouselData.cards.length}px`,
              height: contentHeight,
            }}
          >
            {carouselData.cards.map((card) => (
              <li key={card._id} className="code7-boteria__card">
                {card.imageUrl ? (
                  <img
                    src={card.imageUrl}
                    alt="Imagem do card"
                    className="code7-boteria__card__image"
                    onClick={() => onImageClick({ ...card, type: 'IMAGE' })}
                  />
                ) : (
                  <div
                    alt="Imagem do card"
                    className="code7-boteria__card__image--empty"
                  />
                )}

                <section className="code7-boteria__card__body">
                  <h3 className="code7-boteria__card__title">{card.title}</h3>
                  <p className="code7-boteria__card__description">
                    {card.description}
                  </p>
                </section>

                {card.buttons &&
                  !!card.buttons.length &&
                  card.buttons.map((button, index) => (
                    <span
                      key={`card-button-${index}`}
                      className="code7-boteria__card__button"
                      hidden={!button.label}
                      onClick={() =>
                        handleButtonClick({
                          clickedCard: card,
                          clickedButton: button,
                        })
                      }
                    >
                      {button.label}
                    </span>
                  ))}
              </li>
            ))}
          </div>
        </div>
      </ul>
    </div>
  );
};

export default Carousel;
